import React, { useState } from "react";
import { useAppSelector } from "../../_App/Redux/hooks";

import {
  ListDepots,
  ListVehiculesInAndOut,
} from "../../_App/Redux/Slices/vehicules/vehiculesSlice";
import {
  calculateTotalTimeInGarage,
  groupByDate,
} from "../../_App/Helpers/helpers";
import _ from "lodash";
import MouvementsDetailsModal from "./MouvementsDetailsModal";

interface ReportTableProps {
  setMonth: React.Dispatch<React.SetStateAction<number>>;
  month: any;
  load: boolean;
  setLoad: React.Dispatch<React.SetStateAction<boolean>>;
}

type RowData = {
  region: string;
  zone: string;
  vehicule: string;
  nom_chauffeur: string;
  chauffeur_code: string;
  data: {
    panne: number;
    assurance: number;
    visite: number;
    fraud_papier: number;
    nbr_entrees: number;
    nbr_sorties: number;
    total_panne: number;
    total_visite: number;
    total_assurance: number;
    total_entretien: number;
    total_fraud_papier: number;
  }[];
};

type Props = {
  InAndOutData: {
    monthStats: RowData[];
  };
  daysArray: { day: number; date: string }[];
  groupByDay: (data: any) => Record<number, any[]>;
  unWorkedDaysGroupedByDriver: Record<string, any[]>;
  openDetailsModal: (row: RowData, date: string) => void;
};

const ReportTable: React.FC<ReportTableProps> = ({
  setMonth,
  month,
  load,
  setLoad,
}) => {
  const InAndOutData = useAppSelector(ListVehiculesInAndOut);
  const groupByDay = (data: any[]) => {
    return _.groupBy(data, (item) => {
      const day = item?.movement_date?.split("-")[2]; // Extract the day part
      return day;
    });
  };
  const currentYear = new Date().getFullYear(); // Get the current year

  const getDaysInMonth = (year: any, month: any) =>
    new Date(year, month, 0).getDate();

  const daysInMonth = getDaysInMonth(currentYear, month);

  const daysArray = Array.from({ length: daysInMonth }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return {
      day,
      date: `${currentYear}-${String(month).padStart(2, "0")}-${day}`,
    };
  });

  const [showModal, setShowModal] = useState(false);
  const [details, setDetails] = useState<undefined | any>(undefined);
  const openDetailsModal = async (row: any, date: any) => {
    const detailsData = await {
      vehicule_code: row?.vehicule_code,
      chauffeur_code: row?.chauffeur_code,
      nom_chauffeur: row?.nom_chauffeur,
      matricule_vehicule: row?.matricule,
      marque_vehicule: row?.marque,
      date: date,
    };
    setDetails(detailsData);
    setShowModal(true);
  };
  const unWorkedDaysGroupedByDriver = _.groupBy(
    InAndOutData.unjustifiedNotWorkedDays,
    "code"
  );
  const totals = {
    panne: 0,
    assurance: 0,
    visite: 0,
    entretien: 0,
    fraud_papier: 0,
    unWorkedDays: 0,
    noSorties: 0,
    noEntrees: 0,
    workingHours: Array(daysArray.length).fill(0),
    workedDays: Array(daysArray.length).fill(0),
  };
  const countOccurrences = (item: any) => {
    return InAndOutData.workedDays.filter(
      (day: any) => day.movement_date === item.date
    ).length;
  };
  InAndOutData?.monthStats?.forEach((row: any) => {
    totals.panne += row.data.reduce(
      (sum: any, item: any) => sum + item.total_panne,
      0
    );
    totals.assurance += row.data.reduce(
      (sum: any, item: any) => sum + item.total_assurance,
      0
    );
    totals.visite += row.data.reduce(
      (sum: any, item: any) => sum + item.total_visite,
      0
    );
    totals.entretien += row.data.reduce(
      (sum: any, item: any) => sum + item.total_entretien,
      0
    );
    totals.fraud_papier += row.data.reduce(
      (sum: any, item: any) => sum + item.total_fraud_papier,
      0
    );

    totals.unWorkedDays +=
      unWorkedDaysGroupedByDriver[row.chauffeur_code]?.length || 0;

    totals.noSorties += row.data.filter(
      (item: any) => item.nbr_sorties === 0
    ).length;
    totals.noEntrees += row.data.filter(
      (item: any) => item.nbr_entrees === 0
    ).length;

    daysArray.forEach((item, i) => {
      const groupedData = groupByDay(row.data);
      if (groupedData[item.day] && groupedData[item.day][0]) {
        totals.workingHours[i] +=
          groupedData[item.day][0].hours_per_day > 0
            ? groupedData[item.day][0].hours_per_day
            : 0;
      }
    });
  });

  type HistoryEntry = { vehicule_code: string, current : any };
  type HistoryData = {
    inHistory: Record<string, HistoryEntry[]>;
    outHistory: Record<string, HistoryEntry[]>;
  };

  const getCommonVehicleCount = (historyData: HistoryData): number => {
    // Create a map to store the latest "sortie" (out) date for each vehicle
    const outDates = new Map<string, string>();
  
    Object.values(historyData.outHistory)
      .flat()
      .forEach((e) => {
        outDates.set(e.vehicule_code, e.current.date);
      });
  
    // Filter vehicles where "entree" (in) date is > "sortie" (out) date
    return Object.values(historyData.inHistory)
      .flat()
      .filter((e) => {
        const outDate = outDates.get(e.vehicule_code);
        return outDate && e.current.date > outDate;
      }).length;
  };
  
  const commonCount = getCommonVehicleCount(InAndOutData);
  console.log("Common vehicle count:", commonCount);
  
  return (
    <>
      {details && (
        <MouvementsDetailsModal
          details={details}
          setDetails={setDetails}
          showModal={showModal}
          setShowModal={setShowModal}
          load={load}
          setLoad={setLoad}
        />
      )}
      <div className="row content-card p-0 m-0">
        <div className="col-12 col-xl-12 stretch-card">
          <div className="col-md-12">
            {InAndOutData?.vehiclesOut && InAndOutData?.vehiclesIn && (
              <div className="row" style={{ padding: "0px 12px" }}>
                <div className="col-3 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fas fa-warehouse text-success"
                          style={{ fontSize: "xx-large", marginRight: "10px" }}
                        ></i>
                        <h6 className="mb-0 text-primary">
                          {`${InAndOutData.monthStats.length} véhicules actuellement au parc`}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-3 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fas fa-sign-out-alt text-danger"
                          style={{ fontSize: "xx-large", marginRight: "10px" }}
                        ></i>
                        <h6 className="mb-0 text-primary">
                          {`${InAndOutData.vehiclesOut.length} véhicules sortis aujourd’hui`}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-3 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fas fa-sign-in-alt text-success"
                          style={{ fontSize: "xx-large", marginRight: "10px" }}
                        ></i>
                        <h6 className="mb-0 text-primary">
                          {`${InAndOutData.vehiclesIn.length} véhicules entrés aujourd’hui`}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-3 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fas fa-exchange-alt text-secondary"
                          style={{ fontSize: "xx-large", marginRight: "10px" }}
                        ></i>
                        <h6 className="mb-0 text-primary">
                          {`${commonCount} véhicules ayant fait une sortie et une entree aujourd’hui`}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row content-card p-0 m-0">
        <div className="col-12 col-xl-12 stretch-card">
          <div className="col-md-12">
            <div className="row" style={{ padding: "0px 12px" }}>
              <div className="col-3 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="fas fa-pause-circle text-danger"
                        style={{ fontSize: "xx-large" }}
                      ></i>
                      <h6 className="mb-0 text-primary">
                        {`${InAndOutData?.notWorkedDays?.length} JOURS NON TRAVAILLE `}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <i
                        className="fas fa-check-circle text-success"
                        style={{ fontSize: "xx-large" }}
                      ></i>
                      <h6 className="mb-0 text-primary">{`${InAndOutData?.workedDays?.length} JOURS TRAVAILLE `}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="fas fa-warehouse"
                        style={{ fontSize: "xx-large" }}
                      ></i>
                      <h6 className="mb-0 text-primary">
                        {calculateTotalTimeInGarage(InAndOutData?.timeInGarage)
                          .days
                          ? calculateTotalTimeInGarage(
                              InAndOutData?.timeInGarage
                            ).days + " JOURS "
                          : calculateTotalTimeInGarage(
                              InAndOutData?.timeInGarage
                            ).hours + " HEURES "}{" "}
                        AU GARAGE
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="fas fa-exclamation-triangle text-danger"
                        style={{ fontSize: "xx-large" }}
                      ></i>

                      <h6 className="mb-0 text-primary">
                        {`${InAndOutData?.unjustifiedNotWorkedDays?.length} ARRET NON JUSTIFIE `}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row content-card mt-2">
        <div className="col-12 col-xl-12 stretch-card">
          <div className="col-md-12">
            <div className="row" style={{ padding: "0px 12px" }}></div>

            <div className="col-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-baseline mb-3">
                    {/* <h6 className="mb-0 text-primary">{"Mouvements"}</h6> */}
                    <div className="legend">
                      <div
                        className="legend-item green"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Panne
                      </div>
                      <div
                        className="legend-item yellow"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Non-Travail
                      </div>
                      <div
                        className="legend-item red"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Pas Sortie
                      </div>
                      <div
                        className="legend-item blue"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Pas Entree
                      </div>
                      <div
                        className="legend-item purple"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Visite
                      </div>
                      <div
                        className="legend-item light-blue"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Assurance
                      </div>
                      <div
                        className="legend-item orange"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        Entretien
                      </div>
                      <div className="legend-item light-peach">
                        {" "}
                        Papiers non reglés
                      </div>
                    </div>
                    <select
                      className="form-select w-auto"
                      value={month}
                      onChange={(e) => setMonth(Number(e.target.value))} // Convert the value to a number
                    >
                      <option value={1}>Janvier</option>
                      <option value={2}>Février</option>
                      <option value={3}>Mars</option>
                      <option value={4}>Avril</option>
                      <option value={5}>Mai</option>
                      <option value={6}>Juin</option>
                      <option value={7}>Juillet</option>
                      <option value={8}>Août</option>
                      <option value={9}>Septembre</option>
                      <option value={10}>Octobre</option>
                      <option value={11}>Novembre</option>
                      <option value={12}>Décembre</option>
                    </select>
                  </div>

                  <div className="table-responsive ">
                    <div className="report-table m-0">
                      <table style={{ fontSize: "10px" }}>
                        <thead>
                          <tr>
                            <th>REGION</th>
                            <th>ZONE</th>
                            <th>MATRICULE</th>
                            <th>CHAUFFEUR</th>

                            {Array.from(
                              { length: daysArray.length },
                              (_, i) => (
                                <th key={i}> {i + 1}</th>
                              )
                            )}
                            <th className="legend-item green"></th>
                            <th className="legend-item yellow"></th>

                            <th className="legend-item red"></th>
                            <th className="legend-item blue"></th>
                            <th className="legend-item purple"></th>
                            <th className="legend-item light-blue"></th>
                            <th className="legend-item orange"></th>
                            <th className="legend-item light-peach"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {InAndOutData?.monthStats?.map(
                            (row: any, rowIndex: any) => (
                              <tr key={rowIndex} className="hoverable-row">
                                <td>{row.region}</td>
                                <td>{row.zone}</td>
                                <td onClick={() => console.log(daysArray)}>
                                  {row.matricule + "/" + row.marque}
                                </td>
                                <td>{row.nom_chauffeur}</td>

                                {daysArray.map((item, i) => {
                                  const groupedData = groupByDay(row.data);
                                  if (
                                    groupedData[item.day]?.[0]?.hours_per_day >
                                    0
                                  )
                                    totals.workedDays[i] += 1;
                                  if (
                                    groupedData &&
                                    groupedData[item.day] &&
                                    groupedData[item.day][0]
                                  ) {
                                    const cellData = groupedData[item.day][0];
                                    let movements = 0;

                                    // Check for fields with a value of 1
                                    movements += cellData?.panne === 1 ? 1 : 0;
                                    movements +=
                                      cellData?.entretien === 1 ? 1 : 0;
                                    movements +=
                                      cellData?.assurance === 1 ? 1 : 0;
                                    movements += cellData?.visite === 1 ? 1 : 0;
                                    movements +=
                                      cellData?.fraud_papier === 1 ? 1 : 0;

                                    let allMovements = 0;

                                    // Check for fields with a value of 1
                                    allMovements +=
                                      cellData?.panne === 1 ? 1 : 0;
                                    allMovements +=
                                      cellData?.entretien === 1 ? 1 : 0;
                                    allMovements +=
                                      cellData?.assurance === 1 ? 1 : 0;
                                    allMovements +=
                                      cellData?.visite === 1 ? 1 : 0;
                                    allMovements +=
                                      cellData?.fraud_papier === 1 ? 1 : 0;
                                    allMovements +=
                                      cellData?.nbr_entrees > 0 ? 1 : 0;
                                    allMovements +=
                                      cellData?.nbr_sorties > 0 ? 1 : 0;

                                    const cellClass =
                                      allMovements === 0
                                        ? "yellow"
                                        : cellData?.entretien
                                        ? "black"
                                        : cellData?.panne
                                        ? "green"
                                        : cellData?.visite
                                        ? "purple"
                                        : cellData?.assurance
                                        ? "light-blue"
                                        : cellData?.fraud_papier
                                        ? "light-peach"
                                        : cellData?.nbr_entrees < 1
                                        ? "blue"
                                        : cellData?.nbr_sorties < 1
                                        ? "red"
                                        : "empty";
                                    return (
                                      <td key={i}>
                                        <div
                                          className={`day-cell ${cellClass}`}
                                          onClick={() => {
                                            cellData &&
                                              openDetailsModal(row, item.date);
                                          }}
                                          style={{ position: "relative" }} // Ensure the parent div has relative positioning
                                        >
                                          {groupedData[item.day]?.[0]
                                            ?.hours_per_day > 0 &&
                                            groupedData[item.day]?.[0]
                                              ?.hours_per_day}{" "}
                                          {movements > 1 ? (
                                            // ||
                                            // (cellData.nbr_entrees > 0 &&
                                            //   cellData.nbr_sorties === 0)
                                            <i
                                              className="fas fa-exclamation-triangle"
                                              style={{
                                                position: "absolute",
                                                bottom: "-5px",
                                                right: "-6px",
                                                color: "red", // Customize color as needed
                                                fontSize: "14px", // Customize size as needed
                                              }}
                                            />
                                          ) : null}
                                        </div>
                                      </td>
                                    );
                                  } else if (
                                    unWorkedDaysGroupedByDriver[
                                      row.chauffeur_code
                                    ]?.some((movement) =>
                                      movement.movement_date.includes(item.date)
                                    )
                                  ) {
                                    return (
                                      <td key={i}>
                                        <div
                                          onClick={() => {
                                            openDetailsModal(row, item.date);
                                          }}
                                          className={`day-cell ${"yellow"}`}
                                        ></div>
                                      </td>
                                    );
                                  } else {
                                    return (
                                      <td key={i}>
                                        <div className={`day-cell ${"empty"}`}>
                                          {InAndOutData?.daysoff?.some(
                                            (record: any) =>
                                              record.date === item.date
                                          )
                                            ? "W"
                                            : groupedData[item.day]?.[0]
                                                ?.hours_per_day > 0
                                            ? groupedData[item.day]?.[0]
                                                ?.hours_per_day
                                            : ""}{" "}
                                        </div>
                                      </td>
                                    );
                                  }
                                })}
                                <td>
                                  {row.data.reduce(
                                    (sum: number, item: any) =>
                                      sum + item.total_panne,
                                    0
                                  )}{" "}
                                </td>
                                <td
                                  onClick={() =>
                                    console.log(
                                      unWorkedDaysGroupedByDriver[
                                        row.chauffeur_code
                                      ]
                                    )
                                  }
                                >
                                  {unWorkedDaysGroupedByDriver[
                                    row.chauffeur_code
                                  ]?.length || 0}{" "}
                                </td>
                                <td>
                                  {
                                    row.data.filter(
                                      (item: any) => item.nbr_sorties === 0
                                    ).length
                                  }{" "}
                                </td>
                                <td>
                                  {
                                    row.data.filter(
                                      (item: any) => item.nbr_entrees === 0
                                    ).length
                                  }{" "}
                                </td>
                                <td>
                                  {row.data.reduce(
                                    (sum: number, item: any) =>
                                      sum + item.total_visite,
                                    0
                                  )}{" "}
                                </td>
                                <td>
                                  {row.data.reduce(
                                    (sum: number, item: any) =>
                                      sum + item.total_assurance,
                                    0
                                  )}{" "}
                                </td>
                                <td>
                                  {row.data.reduce(
                                    (sum: number, item: any) =>
                                      sum + item.total_entretien,
                                    0
                                  )}{" "}
                                </td>
                                <td>
                                  {row.data.reduce(
                                    (sum: number, item: any) =>
                                      sum + item.total_fraud_papier,
                                    0
                                  )}{" "}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan={4}>Total</td>
                            {totals.workedDays.map((hours, i) => (
                              <td key={i}>{hours > 0 ? hours : "0"}</td>
                            ))}
                            <td>{totals.panne}</td>
                            <td
                              onClick={() => console.log(totals.unWorkedDays)}
                            >
                              {totals.unWorkedDays ? totals.unWorkedDays : 0}
                            </td>
                            <td>{totals.noSorties}</td>
                            <td>{totals.noEntrees}</td>
                            <td>{totals.visite}</td>
                            <td>{totals.assurance}</td>
                            <td>{totals.entretien}</td>
                            <td>{totals.fraud_papier}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportTable;
